import React from 'react';
import { Tabs } from 'antd';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';

/* extracting Tab pane from Tabs */
const { TabPane } = Tabs;

/* React functional component */
const InwardShipmentReportTabLayout = (): JSX.Element => {
  /* extracting navigate from useNavigate() */
  const navigate = useNavigate();
  /* useLocation destructuring */
  const location = useLocation();

  /* function to get the active tab key */
  const getActiveKey = () => {
    if (location.pathname.includes('bags')) {
      return 'bagsKey';
    }
    if (location.pathname.includes('otherItems')) {
      return 'otherItemsKey';
    }
    return 'rawMaterialKey';
  };

  return (
    <div className="tabLayout">
      <Tabs
        defaultActiveKey="rawMaterialKey"
        onTabClick={(key: string) => {
          if (key === 'bagsKey') {
            navigate('bags');
          } else if (key === 'otherItemsKey') {
            navigate('otherItems');
          } else {
            navigate('paddy');
          }
        }}
        activeKey={getActiveKey()}
        tabBarGutter={50}
        destroyInactiveTabPane
      >
        <TabPane tab="Raw Material (paddy)" key="rawMaterialKey">
          <Outlet />
        </TabPane>
        <TabPane tab="Bags" key="bagsKey">
          <Outlet />
        </TabPane>
        <TabPane tab="Other Items" key="otherItemsKey">
          <Outlet />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default InwardShipmentReportTabLayout;
